import api, { ApiResponse } from "../api";

class EmployeeNotificationService {
  private static instance: EmployeeNotificationService;
  private constructor() {}
  static getInstance(): EmployeeNotificationService {
    if (!EmployeeNotificationService.instance) {
      EmployeeNotificationService.instance = new EmployeeNotificationService();
    }
    return EmployeeNotificationService.instance;
  }

  public subscribeToProbill = async (
    email: string,
    probillNumber: number
  ): Promise<ApiResponse<any>> => {
    return await api.post(`/emp-notifications/probill-subscriptions/email/${encodeURIComponent(email)}/probill/${encodeURIComponent(probillNumber.toString())}`);
  };

  public unsubscribeFromProbill = async (
    email: string,
    probillNumber: number
  ): Promise<ApiResponse<any>> => {
    return await api.delete(`/emp-notifications/probill-subscriptions/email/${encodeURIComponent(email)}/probill/${encodeURIComponent(probillNumber.toString())}`);
  };
  
  public getSubscribedProbills = async (
    email: string
  ): Promise<ApiResponse<number[]>> => {
    return await api.get(`/emp-notifications/probill-subscriptions/email/${encodeURIComponent(email)}`);
  };
}

export default EmployeeNotificationService;


